import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button,IconButton, Typography } from "@mui/material";
import {
  DayOffSection,
  HolidaysSection,
  SectionDelimiter,
  WorkingTimeSection,
} from "src/components/SideBar/CalendarSideBar/components";
import { UserRoles } from "src/constants/user";
import { elementStyle } from "src/utils/helpers";

import { CloseIcon, PenMenuIcon } from "../../Icons";
import {
  setWorkingTimeDialogParams,
  showWorkingTimeDialog,
} from "../../store/reducers/dialogSlice";
import { closeDrawer } from "../../store/reducers/drawerSlice";
import { resetSelectedRow } from "../../store/reducers/tableSlice";

export const RightWorkingTimeDrawer = () => {
  const dispatch = useDispatch();

  const { user } = useSelector((state: any) => state.auth);
  // @ts-ignore
  const role = UserRoles[user?.role];
  const { isShown } = useSelector((state: any) => state.drawer);
  const { selectedRow: rowData } = useSelector((state: any) => state.table);

  const handleClose = () => {
    dispatch(resetSelectedRow());
    dispatch(closeDrawer());
  };

  const getBasicEditParams = () => {
    return {
      step: 0,
      maxAvailableStep: 1,
      isEdit: true,
      data: rowData,
    };
  };

  const handleEditAllButton = () => {
    handleClose();
    setTimeout(() => {
      dispatch(setWorkingTimeDialogParams(getBasicEditParams()));
      dispatch(showWorkingTimeDialog());
    }, 100);
  };

  const handleEditBasicInfoButton = () => {
    handleClose();
    dispatch(setWorkingTimeDialogParams(getBasicEditParams()));
    dispatch(showWorkingTimeDialog());
  };

  const handleEditScheduleRulesButton = () => {
    handleClose();
    dispatch(
      setWorkingTimeDialogParams({
        ...getBasicEditParams(),
        step: 1,
      })
    );
    dispatch(showWorkingTimeDialog());
  };

  return (
    <Box
      sx={{
        position: "fixed",
        width: "424px",
        height: "auto",
        zIndex: 1000,
        backgroundColor: "#F3F3F3",
        top: 82,
        right: "0px",
        display: isShown ? "block" : "none",
        transition: "right 0.3s",
        boxShadow: isShown
          ? "rgba(0, 0, 0, 0.1) -3px 10px 15px 0px"
          : undefined,
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          height: "62px",
          backgroundColor: "white",
          padding: "10px 16px",
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            width: "32px",
            height: "32px",
            borderRadius: "6px",
            backgroundColor: "#F3F3F3",
            color: "#676767",
            fontSize: "20px",
          }}
          disableRipple
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>
        <Box>
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
            }}
          >
            About template
          </Typography>
        </Box>
        <Box />
        <Button
          sx={{
            fontSize: "14px",
            fontWeight: "400",
            display: elementStyle({
              role,
              roleType: "ADMIN",
              firstOption: "none",
              lastOption: "inline-flex",
            }),
          }}
          onClick={handleEditAllButton}
          disableRipple
        >
          Edit all
        </Button>
      </Box>

      <Box
        sx={{
          height: "calc(100vh - 82px - 62px)",
          overflowY: "auto",
        }}
      >
        <Box
          display="flex"
          sx={{
            padding: "16px 16px",
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            sx={{
              backgroundColor: "white",
              flex: 1,
              borderRadius: "6px",
              padding: "16px 16px 24px",
              boxShadow: "0px 4px 16px 0px rgba(41, 66, 90, 0.12)",
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                flex: 1,
                marginBottom: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Basic information
              </Typography>
              <IconButton
                onClick={handleEditBasicInfoButton}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#BF295C",
                  fontSize: "16px",
                  display: elementStyle({
                    role,
                    roleType: "ADMIN",
                    firstOption: "none",
                    lastOption: "inline-flex",
                  }),
                }}
                disableRipple
              >
                <PenMenuIcon fontSize="inherit" />
              </IconButton>
            </Box>

            <Box
              display="flex"
              alignItems="center"
              sx={{
                flex: 1,
              }}
            >
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                sx={{
                  height: "100%",
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      color: "#828282",
                    }}
                  >
                    Template name
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#080808",
                      marginBottom: "18px",
                    }}
                  >
                    {rowData.title}
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      textTransform: "uppercase",
                      fontSize: "12px",
                      color: "#828282",
                    }}
                  >
                    Additional name
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#080808",
                    }}
                  >
                    {rowData.description}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          display="flex"
          sx={{
            padding: "0 16px 16px",
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            sx={{
              backgroundColor: "white",
              flex: 1,
              borderRadius: "6px",
              padding: "16px 16px 24px",
              boxShadow: "0px 4px 16px 0px rgba(41, 66, 90, 0.12)",
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                flex: 1,
                marginBottom: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Schedule rules
              </Typography>

              <IconButton
                onClick={handleEditScheduleRulesButton}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#BF295C",
                  fontSize: "16px",
                  display: elementStyle({
                    role,
                    roleType: "ADMIN",
                    firstOption: "none",
                    lastOption: "inline-flex",
                  }),
                }}
                disableRipple
              >
                <PenMenuIcon fontSize="inherit" />
              </IconButton>
            </Box>
            <Box>
              <WorkingTimeSection workingTimes={rowData?.workingTimes} />
              <SectionDelimiter />
              <HolidaysSection
                holidays={rowData?.holidays}
                lastUpdated={rowData?.updatedAt}
              />
              <SectionDelimiter />
              <DayOffSection daysOff={rowData?.daysOff} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
